import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import {startTitleEdit, hideOrShowActiveField} from '../../Common/actions/Field';
import {cloneActiveField, restoreActiveField, deleteActiveReportField} from '../actions/Field';
import * as itemTypes from '../../../../constants/ItemTypes';
import {hiddenFieldTypes} from '../../../../constants/FieldConsts';
import {texts, getLocalizedText} from '../../../../constants/TextConst';
import {
    showWarnMessage,
    showUnsavedChangesMessages
} from '../../../../_shared/Messages/actions/MessageActions';
import {messagesIds} from '../../../../_shared/Messages/consts';
import ActionsMenu, {ActionItem} from '../../../../components/Common/ActionsMenu';
import AttributesPanel from './AttributesPanel';

@observer
export default class SystemReportMenu extends Component<any, any> {
    constructor(props) {
        super(props);

        this.showHideItem = this.showHideItem.bind(this);
        this.cloneTab = this.cloneTab.bind(this);
        this.changeName = this.changeName.bind(this);
        this.restoreReportTab = this.restoreReportTab.bind(this);
        this.deleteReportTab = this.deleteReportTab.bind(this);
    }

    showHideItem() {
        const {field} = this.props;
        const {parentField} = field;

        const alertMessage =
            field.repType === itemTypes.Field
                ? getLocalizedText(texts.packHiddenRepColText)
                : getLocalizedText(texts.packHiddenRepText);

        // TODO: move logic of warn messages to actions
        if (
            field.hidden == hiddenFieldTypes.HIDDEN_BOTH || // eslint-disable-line eqeqeq
            field.hidden == hiddenFieldTypes.HIDDEN_IN_PACKAGE // eslint-disable-line eqeqeq
        ) {
            showWarnMessage({
                id: messagesIds.screens.showHiddenItemWarn,
                title: alertMessage,
                onClose: () => {
                    return;
                }
            });
            return;
        }
        if (parentField) {
            if (
                parentField.hidden == hiddenFieldTypes.HIDDEN_BOTH || // eslint-disable-line eqeqeq
                parentField.hidden == hiddenFieldTypes.HIDDEN_IN_PACKAGE // eslint-disable-line eqeqeq
            ) {
                showWarnMessage({
                    id: messagesIds.screens.showHiddenItemWarn,
                    title: getLocalizedText(texts.packHiddenRepColText),
                    onClose: () => {
                        return;
                    }
                });
                return;
            }

            if (
                parentField.parentField &&
                (parentField.parentField.hidden == hiddenFieldTypes.HIDDEN_BOTH || // eslint-disable-line eqeqeq
                    parentField.parentField.hidden == hiddenFieldTypes.HIDDEN_IN_PACKAGE) // eslint-disable-line eqeqeq
            ) {
                showWarnMessage({
                    id: messagesIds.screens.showHiddenItemWarn,
                    title: getLocalizedText(texts.packHiddenRepColText),
                    onClose: () => {
                        return;
                    }
                });
                return;
            }
        }

        hideOrShowActiveField(field);
    }

    cloneTab() {
        const {field} = this.props;
        cloneActiveField(field);
    }

    changeName() {
        const {field} = this.props;
        startTitleEdit(field);
    }

    renderAttributesPanel(type, props) {
        const {field, funcs, fontFamilies} = this.props;
        const title =
            type === 'attributes'
                ? getLocalizedText(texts.fieldAttributes)
                : getLocalizedText(texts.titleAttributes);
        const dateFormats = funcs && funcs.getdateFormats && funcs.getdateFormats();

        return (
            <AttributesPanel
                field={field}
                type={type}
                title={title}
                dateFormats={dateFormats}
                fontFamilies={fontFamilies}
                {...props}
            />
        );
    }

    restoreReportTab() {
        // TODO: move logic of warn messages to actions
        showUnsavedChangesMessages(
            getLocalizedText(texts.restoreWarn),
            () => {
                const {field} = this.props;
                restoreActiveField(field);
            },
            () => {
                return;
            }
        );
    }

    deleteReportTab() {
        // TODO: move logic of warn messages to actions
        showUnsavedChangesMessages(
            getLocalizedText(texts.deleteWarn),
            () => {
                const {field} = this.props;
                deleteActiveReportField(field);
            },
            () => {
                return;
            }
        );
    }

    render() {
        const {field} = this.props;
        const isHidden =
            field &&
            (field.isHiddenImage ||
                (field.repType === itemTypes.Field && field.parentField.isHiddenImage));
        return (
            <ActionsMenu open={this.props.open}>
                <div>
                    <ActionItem
                        title={
                            isHidden ? getLocalizedText(texts.show) : getLocalizedText(texts.hide)
                        }
                        disabled={field && field.mayFieldShow && field.needed}
                        onActionClick={this.showHideItem}
                    />

                    <ActionItem
                        title={getLocalizedText(texts.duplicate)}
                        disabled={field && field.parentField !== field.screen}
                        onActionClick={this.cloneTab}
                    />

                    <ActionItem
                        title={getLocalizedText(texts.rename)}
                        disabled={field && !field.mayFieldRename}
                        onActionClick={this.changeName}
                    />

                    <ActionItem
                        title={getLocalizedText(texts.fieldAttributes)}
                        disabled={field && !field.showDesignField}
                        renderSubmenu={props => this.renderAttributesPanel('attributes', props)}
                    />

                    <ActionItem
                        title={getLocalizedText(texts.titleAttributes)}
                        disabled={field && !field.showDesignTitle}
                        renderSubmenu={props => this.renderAttributesPanel('title', props)}
                    />

                    <ActionItem
                        title={getLocalizedText(texts.defaults)}
                        disabled={field && !field.mayRestore}
                        onActionClick={this.restoreReportTab}
                    />

                    <ActionItem
                        className="delete"
                        title={getLocalizedText(texts.del)}
                        disabled={field && !field.mayFieldDelete}
                        onActionClick={this.deleteReportTab}
                    />
                </div>
            </ActionsMenu>
        );
    }
}
